(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sl-rail')) {
  class SlRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-rail__track');
      this.prev = this.querySelector('.sl-rail__nav--prev');
      this.next = this.querySelector('.sl-rail__nav--next');
      if (!this.track) return;
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }
    go(dir) {
      const item = this.track.firstElementChild;
      const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.hidden = this.track.scrollLeft <= 2;
      if (this.next) this.next.hidden = this.track.scrollLeft >= max;
    }
  }
  customElements.define('sl-rail', SlRail);
}
  } catch(e) { console.error(e); }
})();

})();
